import _ from 'lodash';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useUpdateEffect } from 'react-use';

import { authActions, selectRefreshToken } from '../store/authSlice';
import { userActions } from '../store/userSlice';
import { useAuthAxios } from './useAuthAxios';

export function useLogout() {
  const dispatch = useDispatch();
  // const accessToken = useSelector(selectAccessToken);
  const refreshToken = useSelector(selectRefreshToken);

  const [deleteTokenResult, deleteToken] = useAuthAxios(
    {
      method: 'DELETE',
      url: `/api/v1/auth/logout`,
      data: { refreshToken: refreshToken },
    },
    { manual: true },
  );

  const navigate = useNavigate();
  const init = useCallback(
    function () {
      const authAction = authActions.changeTokens({
        accessToken: '',
        refreshToken: '',
      });
      dispatch(authAction);

      const userAction = userActions.initUser();
      dispatch(userAction);

      navigate('/login');
    },
    [dispatch, navigate],
  );

  const status =
    _.get(deleteTokenResult, 'response.status') ||
    _.get(deleteTokenResult, 'error.response.status');
  const loading = _.get(deleteTokenResult, 'loading');
  useUpdateEffect(() => {
    if (!loading && typeof status === 'number') {
      init();
    }
  }, [init, status, loading]);

  return { logout: () => deleteToken() };
}
